import axios from "axios";
import { first, get, isArray, size } from "lodash";
import moment from "moment";
import {
  all,
  call,
  cancelled,
  delay,
  fork,
  put,
  select,
  takeLatest
} from "redux-saga/effects";
import { openToast } from "~/components/common/molecules/ToastNotification";
import history from "~/history";
import * as hospitalActions from "~/store/hospital/hospitalActions";
import * as notiAction from "~/store/notifications/notificationsActions";
import * as patientActions from "~/store/patient/patientAction";
import patientType from "~/store/patient/patientType";
import * as paymentTypes from "~/store/payment/paymentType";
import * as types from "~/store/totalData/types";
import { huyi } from "~/utils/clog";
import {
  REDIRECT_URL_AFTER_BOOKING,
  SERVICE_TYPE_BOTH
} from "~/utils/constants";
import {
  convertDataToMutipleBookings,
  getDataToReserve,
  getStepFollowTreeMap,
  routerByPartnerId
} from "~/utils/func";
import { client } from "~/utils/medproSDK";
import AppId from "~/utils/partner";
import { handleUnAuthorize } from "~/utils/unAuthorize";
import { GET_ALL_MEDICAL_BILLS_SUCCESS } from "../booking/bookingType";
import { offLoading, onLoading } from "./actions";
import {
  selectHospitalInfo,
  selectHospitalDescription
} from "~/store/hospital/hospitalActions";

const nodeAction = {
  service: {
    typeSelect: types.SELECT_SERVICE,
    typeReset: types.RESET_SELECT_SERVICE,
    url: "/chon-dich-vu"
  },
  subject: {
    typeSelect: types.SELECT_SUBJECT,
    typeReset: types.RESET_SELECT_SUBJECT,
    url: "/chon-chuyen-khoa"
  },
  doctor: {
    typeSelect: types.SELECT_DOCTOR,
    typeReset: types.RESET_SELECT_DOCTOR,
    url: "/chon-bac-si"
  },
  room: {
    typeSelect: types.SELECT_ROOM,
    typeReset: types.RESET_SELECT_ROOM,
    url: "/chon-phong-kham"
  }
};

function* requestIPAddress() {
  try {
    const response = yield call(fetch, "https://api.ipify.org?format=json");
    const data = yield response.json();
    return data.ip;
  } catch (error) {
    console.log(error);
  }
}

// getExtraConfig
function* requestExtraConfig() {
  try {
    const global = yield select(state => state.global);
    const platformType = get(global, "device.type");
    const platform = platformType === "desktop" ? "pc" : "web";
    const partnerid = yield select(state => state.totalData.partnerId);
    const response = yield client.getExtraConfig({ partnerid, platform });

    yield put({
      type: types.GET_EXTRA_CONFIG_SUCCESS,
      payload: response.data
    });
  } catch (error) {
    console.log(error);
  }
}

function* requestExtraConfigWatcher() {
  yield takeLatest(types.GET_EXTRA_CONFIG, requestExtraConfig);
}

// Booking Tree
function* requestBookingTree({ text, id, isAddNew }) {
  try {
    yield put(onLoading());

    const global = yield select(state => state.global);
    const platformType = get(global, "device.type");
    const platform = platformType === "desktop" ? "pc" : "web";

    yield put(hospitalActions.requestHospitalList());

    const partnerid = yield select(state => state.totalData.partnerId);
    const flow = yield select(state => state.totalData.flow);
    const schedulesSelected = yield select(
      state => state.totalData.schedulesSelected
    );

    const finalPartnerID = id || partnerid;

    let payload = {
      treeId: flow.toUpperCase()
    };
    if (schedulesSelected.length >= 1) {
      payload = {
        ...payload,
        date: moment(schedulesSelected[0].date).format("DDMMYYYY")
      };
    }
    axios.defaults.headers.partnerid = finalPartnerID;
    const response = yield client.getBookingTreeDynamic(payload, {
      partnerid: finalPartnerID,
      appid: AppId,
      platform
    });

    if (schedulesSelected.length >= 1) {
      const { child } = response.data;

      const listSelectedById = schedulesSelected?.map(({ subject }) => {
        return subject.id;
      });
      const listSelectedByName = schedulesSelected?.map(({ subject }) => {
        return subject.name;
      });

      const listFilterByDoctor = child?.filter(({ detail }) => {
        return !listSelectedByName?.includes(detail.subject);
      });

      const listFilterbyDate = child?.filter(
        ({ id }) => !listSelectedById?.includes(id)
      );

      response.data.child =
        flow.toUpperCase() === "DATE" ? listFilterbyDate : listFilterByDoctor;
    }
    console.log("response.data", response.data);
    yield put({
      type: types.GET_BOOKING_TREE_SUCCESS,
      payload: response.data,
      id: finalPartnerID,
      treeId: flow.toUpperCase()
    });

    if (isAddNew) {
      const route = routerByPartnerId(
        getStepFollowTreeMap(response.data.subType, finalPartnerID),
        finalPartnerID
      );
      history.push(route);
    }

    const stepOne = getStepFollowTreeMap(response.data.subType, finalPartnerID);
    const firstNode = get(response, "data.child", []);
    const firstType = get(response, "data.subType");

    console.log("stepOne :>> ", stepOne);

    if (!text) {
      if (firstNode.length === 1) {
        if (
          firstType === "service" &&
          firstNode[0].detail.serviceType === "BOTH"
        ) {
          history.push(stepOne);
        } else {
          if (firstNode[0].detail.popupType === 1) {
            history.push(stepOne);
          } else {
            yield put({
              type: nodeAction[firstType].typeSelect,
              payload: firstNode[0]
            });
          }
        }
      } else {
        history.push(stepOne);
      }
    }

    yield put(hospitalActions.selectHospital(finalPartnerID));
    yield put(offLoading());
  } catch (error) {
    yield put(offLoading());
    console.log("error requestBookingTree :>> ", error);
  }
}

function* requestBookingTreeWatcher() {
  yield takeLatest(types.GET_BOOKING_TREE, requestBookingTree);
}

//  Sub Booking Tree
function* requestSubBookingTree() {
  try {
    const global = yield select(state => state.global);
    const platformType = get(global, "device.type");
    const platform = platformType === "desktop" ? "pc" : "web";

    const serviceId = yield select(state => state.totalData.service.id);
    const doctorId = yield select(state => state.totalData.doctor.id);
    const subjectId = yield select(state => state.totalData.subject.id);
    const roomId = yield select(state => state.totalData.room.id);
    const partnerid = yield select(state => state.totalData.partnerId);
    const flow = yield select(state => state.totalData.flow);

    const schedulesSelected = yield select(
      state => state.totalData.schedulesSelected
    );
    let payload = {
      treeId: flow.toUpperCase(),
      serviceId,
      doctorId,
      subjectId,
      roomId
    };
    if (schedulesSelected.length >= 1) {
      payload = {
        ...payload,
        date: moment(schedulesSelected[0].date).format("DDMMYYYY")
      };
    }
    const response = yield client.getBookingTreeCurrentNode(payload, {
      partnerid,
      appid: AppId,
      platform
    });

    const { type } = response.data;
    yield put({ type: types.UPDATE_CURRENT_NODE, node: response.data });
    yield put({ type: nodeAction[type].typeSelect, payload: response.data });
  } catch (error) {
    console.log(error);
  }
}

function* requestSubBookingTreeWatcher() {
  yield takeLatest(types.GET_SUB_BOOKING_TREE, requestSubBookingTree);
}

// Reserve Booking
function* requestReserveBooking() {
  try {
    let paramsVisa;
    const token = yield select(state => state.user.info.token);
    const totalDataReducer = yield select(state => state.totalData);
    const globalReducer = yield select(state => state.global);
    const paymentMethodReducer = yield select(state => state.payment);
    const patientReducer = yield select(state => state.patient);
    const reExamReducer = yield select(state => state.followUpExam);
    const partnerid = get(totalDataReducer, "partnerId");

    const platformType = get(globalReducer, "device.type");
    const ipAddress = yield call(requestIPAddress);
    if (paymentMethodReducer?.checkEmail) {
      paramsVisa = {
        customerIpAddress: ipAddress,
        browserScreenHeight: window.innerHeight,
        browserScreenWidth: window.innerWidth
      };
    }
    const postData = {
      ...getDataToReserve(
        totalDataReducer,
        globalReducer,
        paymentMethodReducer,
        patientReducer,
        reExamReducer
      ),
      ...paramsVisa
    };
    postData.redirectUrl = REDIRECT_URL_AFTER_BOOKING;

    const response = yield client.reserveBooking(postData, {
      partnerid,
      appid: AppId,
      token,
      platform: platformType === "desktop" ? "pc" : "web"
    });

    const { data } = response;

    if (data.isGateway === 1) {
      yield put({
        type: types.RESERVE_BOOKING_SUCCESS,
        payload: data
      });
      window.location.href = data.qrCodeUrl;
    } else if (data.isGateway === 0) {
      if (postData.methodId === "SHARE_PAYMENT") {
        history.push(`/phieu-kham-benh/chi-tiet/${data.transactionId}`);
      } else {
        history.push(
          `/chi-tiet-phieu-kham-benh?mpTransaction=${data.transactionId}`
        );

        yield put({
          type: types.GET_PAYMENT_INFO_SUCCESS,
          payload: response.data
        });
      }
    }
  } catch (error) {
    const { statusCode, message } = get(error, "response.data", "");
    openToast(message, "error");
    if (statusCode === 401) {
      handleUnAuthorize();
    }
    yield put({
      type: types.RESERVE_BOOKING_FAILURE
    });
  }
}

function* requestReserveBookingWatcher() {
  yield takeLatest(types.RESERVE_BOOKING, requestReserveBooking);
}

function* requestReserveMutipleBookings() {
  try {
    let paramsVisa;
    const token = yield select(state => state.user.info.token);
    const totalDataReducer = yield select(state => state.totalData);
    const globalReducer = yield select(state => state.global);
    const paymentMethodReducer = yield select(state => state.payment);
    const patientReducer = yield select(state => state.patient);
    const reExamReducer = yield select(state => state.followUpExam);
    const partnerid = get(totalDataReducer, "partnerId");
    const platformType = get(globalReducer, "device.type");
    const platform = platformType === "desktop" ? "pc" : "web";

    const ipAddress = yield call(requestIPAddress);
    if (paymentMethodReducer?.checkEmail) {
      paramsVisa = {
        customerIpAddress: ipAddress,
        browserScreenHeight: window.innerHeight,
        browserScreenWidth: window.innerWidth
      };
    }
    const postData = {
      ...convertDataToMutipleBookings(
        totalDataReducer,
        globalReducer,
        paymentMethodReducer,
        patientReducer,
        reExamReducer
      ),
      ...paramsVisa
    };
    postData.redirectUrl = REDIRECT_URL_AFTER_BOOKING;

    const response = yield client.reserveMultipleBookings(postData, {
      partnerid,
      appid: AppId,
      token,
      platform
    });
    const { data } = response;
    if (data.isGateway === 1) {
      yield put({
        type: types.RESERVE_BOOKING_SUCCESS,
        payload: data
      });
      window.location.href = data.qrCodeUrl;
    } else if (data.isGateway === 0) {
      if (postData.methodId === "SHARE_PAYMENT") {
        history.push(`/phieu-kham-benh/chi-tiet/${data.transactionId}`);
      } else {
        history.push(
          `/chi-tiet-phieu-kham-benh?mpTransaction=${data.transactionId}`
        );
      }
      yield put({
        type: types.GET_PAYMENT_INFO_SUCCESS,
        payload: response.data
      });
    }
  } catch (error) {
    huyi({
      name: "client.reserveMultipleBookings",
      child: error,
      type: "error"
    });
    const { statusCode, message } = get(error, "response.data", "");
    openToast(message, "error");
    if (statusCode === 401) {
      handleUnAuthorize();
    }
    yield put({
      type: types.RESERVE_BOOKING_FAILURE
    });
  }
}

function* requestReserveMutipleBookingsWatcher() {
  yield takeLatest(
    types.RESERVE_MULTIPLE_BOOKINGS,
    requestReserveMutipleBookings
  );
}

function* requestBookingShareToPay({ id }) {
  try {
    const global = yield select(state => state.global);
    const platformType = get(global, "device.type");
    const platform = platformType === "desktop" ? "pc" : "web";
    const response = yield client.bookingShareToPay({ id }, { platform });
    const { data } = response;

    const { paymentStatus, description, patient } = data;

    if (paymentStatus === 2) {
      history.push("/");
      openToast(description, "error");
    }

    yield put({
      type: types.BOOKING_SHARE_TO_PAGE_SUCCESS,
      payload: { bookingInfo: data }
    });

    yield put({
      type: patientType.SELECTED_PATIENT_DETAIL,
      value: patient
    });

    yield put({
      type: paymentTypes.UMC_GET_ALL_PAYMENT_METHODS
    });
  } catch (error) {
    console.log("error :>> ", error);
    const errorCode = get(error, "response.data.statusCode", 0);
    const message = get(error, "response.data.message", "");
    if (errorCode) {
      history.push("/");
      openToast(message, "error");
    }
  }
}

// Repayment Booking
function* requestRepaymentBooking(payload) {
  try {
    let paramsVisa, response;
    const { typeRepay, params } = payload;
    const totalReducer = yield select(state => state.totalData);

    const partnerid =
      totalReducer.paymentInformation?.bookingInfo?.partnerId ||
      (yield select(state => state.totalData.partnerId));

    const paymentMethodReducer = yield select(state => state.payment);

    const methodId = get(paymentMethodReducer, "methodId", "");

    const paymentTypeDetail = get(
      paymentMethodReducer,
      "selectedMethod.code",
      ""
    );

    const id = isArray(totalReducer.paymentInformation)
      ? totalReducer.paymentInformation[0]?.bookingInfo?.id
      : totalReducer.paymentInformation?.bookingInfo?.id;

    const status = totalReducer.paymentInformation[0]?.bookingInfo?.status;

    const redirectUrl = REDIRECT_URL_AFTER_BOOKING;

    const global = yield select(state => state.global);
    const platformType = get(global, "device.type");
    const platform = platformType === "desktop" ? "pc" : "web";
    const header = {
      partnerid,
      platform
    };
    const ipAddress = yield call(requestIPAddress);
    if (paymentMethodReducer?.methodId) {
      paramsVisa = {
        customerIpAddress: ipAddress,
        browserScreenHeight: window.innerHeight,
        browserScreenWidth: window.innerWidth,
        ...params
      };
    }
    const postData = {
      methodId,
      paymentTypeDetail,
      redirectUrl,
      id,
      ...paramsVisa
    };
    console.log("typeRepay :>> ", typeRepay);
    if (typeRepay === "shareToPay") {
      response = yield client.rePaymentShareToPayByInfo(postData, header);
    } else {
      response = yield client.rePayment(postData, header);
    }

    const { data } = response;

    if (data.isGateway === 1) {
      yield put({
        type: types.RESERVE_BOOKING_SUCCESS,
        payload: data
      });

      // Đá theo qrCodeUrl đc trả về
      window.location.href = data.qrCodeUrl;
    } else if (data.isGateway === 0) {
      if (Number(status) === 6) {
        history.push(`/chi-tiet-phieu-kham-benh`);
      } else {
        history.push(
          `/chi-tiet-phieu-kham-benh?mpTransaction=${data.transactionId}`
        );

        yield put({
          type: types.GET_PAYMENT_INFO_SUCCESS,
          payload: response.data
        });
      }
    }
  } catch (error) {
    const message = get(error, "response.data.message", "");
    openToast(message, "error");
    yield put({
      type: types.RESERVE_BOOKING_FAILURE
    });
  }
}

function* requestBookingShareToPayWatcher() {
  yield takeLatest(types.BOOKING_SHARE_TO_PAGE, requestBookingShareToPay);
}

function* requestRepaymentBookingWatcher() {
  yield takeLatest(types.REPAYMENT_BOOKING, requestRepaymentBooking);
}

// Payment Info
function* requestPaymentInfo(action) {
  const transactionId = get(action, "payload", "");
  const typePaymentFormShare = yield select(
    state => state.totalData.typePayment
  );
  try {
    const global = yield select(state => state.global);
    const platformType = get(global, "device.type");
    const platform = platformType === "desktop" ? "pc" : "web";
    if (typePaymentFormShare === "SHARE_PAYMENT") {
      history.push("/");
    }

    const partnerid = yield select(state => state.totalData.partnerId);

    const text = get(action, "text", "");
    const typePayment = get(action, "typePayment");
    const postData = {
      transactionId,
      type: typePayment
    };
    const response = yield client.getPaymentInfo(postData, {
      partnerid,
      platform
    });

    //  nếu đi luồng booking sẽ trả về payment , site: chi-tiet-phieu-kham-benh
    if (text === "payment") {
      const status = get(response, "data.bookingInfo.status", 0);
      const description = get(response, "data.bookingInfo.description", 0);

      if (status === 1) {
        description && openToast(description);
      } else {
        description && openToast(description, "error");
      }
      yield put({
        type: types.GET_PAYMENT_INFO_SUCCESS,
        payload: response.data
      });
    }
    //  nếu đi luồng thanh toán viện phí sẽ trả về hospitalFee, láy thông tin của hospitalFee show kêt quả,
    // site: ket-qua-thanh-toan-vien-phi?mpTransaction=VP211110OKY5A1U2NCJW
    else if (text === "hospitalFee") {
      const status = get(response, "data.gatewayInfo.status", 0);
      const message = get(response, "data.gatewayInfo.message", "");

      if (status === 1 || status === 2) {
        message && openToast(message);
      } else {
        message && openToast(message, "error");
      }
      yield put({
        type: types.GET_PAYMENT_INFO_SUCCESS,
        payload: response.data
      });
    }
  } catch (error) {
    huyi({ name: "error-requestPaymentInfo", child: error, type: 0 });

    const text = get(action, "text", "");
    if (text === "payment") {
      if (typePaymentFormShare === "SHARE_PAYMENT") {
        history.push("/");
      } else {
        history.push(`/phieu-kham-benh/chi-tiet/${transactionId}`);
      }
      openToast("Thanh toán không thành công!", "error");
    } else {
      history.push("/user");
      openToast("Có lỗi xảy ra, vui lòng thử lại!", "error");
    }
  } finally {
    yield put(notiAction.getNotificationOnPage({ category: 1 }));
    window.localStorage.setItem("transId", JSON.stringify(transactionId));
  }
}

function* requestPaymentInfoWatch() {
  yield takeLatest(types.GET_PAYMENT_INFO, requestPaymentInfo);
}

function* getBookingInfo(action) {
  try {
    const global = yield select(state => state.global);
    const platformType = get(global, "device.type");
    const platform = platformType === "desktop" ? "pc" : "web";

    yield put(onLoading());
    const partnerid = yield select(state => state.totalData.partnerId);

    const transactionId = get(action, "payload", "");

    const post = {
      transactionId
    };
    const token = yield select(state => state.user.info.token);

    const response = yield client.getBookingWithTransactionCode(post, {
      partnerid,
      token,
      platform
    });

    const patient = get(response, "data.patientInfo");

    if (patient) {
      yield put(patientActions.selectPatientFromData(patient));
    }

    yield put({
      type: types.GET_PAYMENT_INFO_SUCCESS,
      payload: response.data
    });

    // Xử lý callback lắng nghe 5s 1 lần , get lấy thông tin phiếu lại trong 5 phút là 60 lần

    const time = 300000;
    const delays = 5000;
    const times = time / delays;
    let completed = false;
    if (response.data.bookingInfo) {
      if (response.data.bookingInfo.status === 6 && !completed) {
        for (let index = 0; index < times; index++) {
          const response = yield client.getBookingWithTransactionCode(post, {
            partnerid,
            token,
            platform
          });
          if (response.data.bookingInfo.status === 1) {
            yield put({
              type: types.GET_PAYMENT_INFO_SUCCESS,
              payload: response.data
            });
            completed = true;
            yield cancelled();
            break;
          }
          yield delay(delays);
        }
      }
    }
  } catch (error) {
    huyi({ name: "error-getBookingInfo", child: error, type: 0 });

    const text = get(action, "text", "");
    if (text === "payment") {
      openToast("Thanh toán không thành công!", "error");
    } else if (text === "hospitalFee") {
      const message = get(error, "response.data.message");
      openToast(message, "error");
    } else {
      const message = get(error, "response.data.message");
      openToast(message, "error");
      history.push("/user");
    }
  } finally {
    yield put(notiAction.getNotificationOnPage({ category: 1 }));
  }
}
function* watchRequestBookingInfo() {
  yield takeLatest(types.GET_BOOKING_INFO, getBookingInfo);
}

// Medicall Bill
function* requestAllMedicalBill() {
  try {
    const global = yield select(state => state.global);
    const platformType = get(global, "device.type");
    const platform = platformType === "desktop" ? "pc" : "web";
    const token = yield select(state => state.user.info.token);
    const partnerid = yield select(state => state.totalData.partnerId);
    const response = yield client.getAllBookingByUserId({
      partnerid,
      appid: AppId,
      token,
      platform
    });
    yield put({
      type: GET_ALL_MEDICAL_BILLS_SUCCESS,
      payload: response.data
    });
  } catch (error) {
    console.log(error);
    const errorCode = get(error, "response.data.statusCode", 0);
    if (errorCode === 401) {
      history.push("/");
    }
    yield put({
      type: types.GET_ALL_MEDICAL_BILLS_FAILURE
    });
  }
}
function* watchRequestAllMedicalBill() {
  yield takeLatest(types.GET_ALL_MEDICAL_BILLS, requestAllMedicalBill);
}

// Medicall Bill hidden

function* requestAllHiddenMedicalBill() {
  try {
    const global = yield select(state => state.global);
    const platformType = get(global, "device.type");
    const platform = platformType === "desktop" ? "pc" : "web";
    const token = yield select(state => state.user.info.token);
    const response = yield client.getAllInvisibleBookingByUserId({
      token,
      platform
    });
    yield put({
      type: types.GET_ALL_HIDDEN_MEDICAL_BILLS_SUCCESS,
      payload: response.data
    });
  } catch (error) {
    console.log(error);
    const errorCode = get(error, "response.data.statusCode", 0);
    if (errorCode === 401) {
      history.push("/");
    }
    yield put({
      type: types.GET_ALL_HIDDEN_MEDICAL_BILLS_FAILURE
    });
  }
}
function* watchRequestAllHiddenMedicalBill() {
  yield takeLatest(
    types.GET_ALL_HIDDEN_MEDICAL_BILLS,
    requestAllHiddenMedicalBill
  );
}

// auto next step
function* requestChangeStepAuto({ payload }) {
  console.log("payload :>> ", payload);

  const partnerId = yield select(state => state.totalData.partnerId);

  const { type, subType, child, dynamic, pickType, end } = payload;

  console.log("type :>> ", type);

  if (pickType) {
    yield put({ type: types.SET_SCHEDULE_WITHOUT_DATE, payload: true });
    yield put({ type: types.ADD_SCHEDULE });
    history.push("/chon-ho-so");
  } else if (dynamic) {
    yield put({ type: types.GET_SUB_BOOKING_TREE });
  } else {
    // const checkBH = serviceType === SERVICE_TYPE_BOTH;
    const nextRoute = getStepFollowTreeMap(subType, partnerId);

    // nếu phần tử đầu tiên bước tiếp theo > 1 thì đi
    if (size(child) > 1) {
      history.push(nextRoute);
    }
    // nếu phần tử đầu tiên bước tiếp theo === 1 thì thực hiện auto skip
    else if (size(child) === 1) {
      // nếu không có subtype thì tới chọn lịch khám
      if (!subType && end) {
        history.push(nextRoute);
      }
      // ngược lại thì kiểm tra skip
      else {
        //  nếu bước kế tiếp là dịch vụ
        if (subType === "service") {
          const addonServices = get(child[0], "detail.addonServices", []);
          const popupType = get(child[0], "detail.popupType", 0);
          // nếu phần tử đầu tiên của dịch vụ : vừa có tiền vừa khám bhyt -> đi tới chọn dịch vụ
          if (first(child).detail.serviceType === SERVICE_TYPE_BOTH) {
            history.push(nextRoute);
          }
          // nếu phần tử đầu tiên của dịch vụ có dịch vụ cộng thêm > 1 và có ghi nhận cam kết bảo hiểm -> đi tới chọn dịch vụ
          else if (addonServices.length > 1 && popupType === 1) {
            // console.log("có dịch vụ cộng thêm thì dừng lại :>> ", 2);
            history.push(nextRoute);
          }
          // ngược lại thì auto skip
          else {
            yield put({
              type: nodeAction[subType].typeSelect,
              payload: first(child)
            });
          }
        }
        // bước kế tiếp là dịch vụ thì auto skip
        else {
          yield put({
            type: nodeAction[subType].typeSelect,
            payload: first(child)
          });
        }
      }
    }

    // nếu phần tử đầu tiên < 1
    else if (size(child) < 1) {
      //  nếu giá trị end ở bước hiện tại là true thì kết thúc tree --> tới bước tiếp theo
      if (end) {
        history.push(nextRoute);
      }
    }
  }
}

function* watchRequestChangeStepAuto() {
  yield takeLatest(types.SELECT_SUBJECT, requestChangeStepAuto);
  yield takeLatest(types.SELECT_SERVICE, requestChangeStepAuto);
  yield takeLatest(types.SELECT_DOCTOR, requestChangeStepAuto);
  yield takeLatest(types.SELECT_ROOM, requestChangeStepAuto);
}

// back action
function* requestGoBack({ node }) {
  const total = yield select(state => state.totalData);
  // const patient = yield select(state => state.patient);
  const listNode = total.listNode;
  const index = listNode.findIndex(item => item === node);
  const serviceTypeDefault = yield select(
    state => state.totalData.service.serviceTypeDefault
  );

  /**
   * index === 0 --> node đầu tiên --> kiểm tra AppId -->
   *     medpro || momo --> kiểm tra list feature
   *           length = 1  --> chọn bệnh viện
   *           length > 1  --> chọn feature
   *     bệnh viện  --> home
   * index > 0 --> kiểm tra list parent
   *     length = 1  --> gọi lại function này
   *     length > 1  --> redirect về node cha
   */
  if (index === 0) {
    if (AppId === "medpro" || AppId === "momo") {
      const listFeature = yield select(
        state => state.features.allFeatures.list
      );
      if (listFeature.length === 1) {
        history.push("/chon-benh-vien");
      } else {
        const url = routerByPartnerId(
          "/chon-hinh-thuc-dat-kham",
          total.partnerId
        );
        history.push(url);
      }
    } else {
      if (total.addNewsSubject) {
        // history.push("/chon-ho-so");
      } else history.push("/chon-ho-so");
    }
  } else {
    const parentName =
      index === -1 ? listNode[listNode.length - 1] : listNode[index - 1];

    const parentNode = yield select(state => state.totalData[parentName]);

    const url = getStepFollowTreeMap(parentNode.type, total.partnerId);
    if (parentNode.list.length > 1) {
      history.push(url);
    } else {
      if (parentNode.type === "service") {
        if (serviceTypeDefault === SERVICE_TYPE_BOTH) {
          history.push(url);
        } else {
          yield put({ type: types.GO_BACK_STEP, node: parentName });
        }
      } else {
        yield put({ type: types.GO_BACK_STEP, node: parentName });
      }
    }
  }
}

function* watchRequestGoBack() {
  yield takeLatest(types.GO_BACK_STEP, requestGoBack);
}

// reset list node
function* resetListNode({ payload }) {
  /**
   * So sánh node với list node
   * Reset toàn bộ các node phía sau
   * Reset ngày tháng: case chọn BH --> tôi không có BH
   */

  // Reset ngày giờ
  yield put({ type: types.RESET_SELECT_DATE });
  yield put({ type: types.RESET_SELECT_TIME_SLOT });

  let listNode = yield select(state => state.totalData.listNode);
  const index = listNode.findIndex(item => item === payload);
  if (index === 0) {
    // reset all
    for (const item of Object.keys(nodeAction)) {
      yield put({ type: nodeAction[item].typeReset });
    }
  } else {
    listNode = listNode.slice(listNode.findIndex(item => item === payload));
    for (const item of listNode) {
      yield put({ type: nodeAction[item].typeReset });
    }
  }
}

function* watchResetListNode() {
  yield takeLatest(types.RESET_LIST_NODE, resetListNode);
}

// Reserve Booking Partner
function* requestReserveBookingPartner() {
  try {
    // call list payment method --> get amount
    yield put({
      type: paymentTypes.UMC_GET_ALL_PAYMENT_METHODS
    });
    const listPaymentMethod = yield select(state => state.payment.data);
    const momoMethod = listPaymentMethod.find(item => item.methodId === "momo");

    // select method MOMO
    yield put({
      type: paymentTypes.SELECTED_PAYMENT_METHOD,
      method: momoMethod.paymentTypes[0],
      methodId: momoMethod.methodId
    });

    // call reserve booking
    yield put({
      type: types.RESERVE_BOOKING
    });
  } catch (error) { }
}

function* watchReserveBookingPartner() {
  yield takeLatest(types.RESERVE_PAYMENT_PARTNER, requestReserveBookingPartner);
}

function* requestPartnerInfo({ payload }) {
  try {
    const total = yield select(state => state.totalData);

    const response = yield client.getPartnerInfo({
      partnerid: payload.partnerId || total.partnerId
    });

    const log = false;
    if (log) {
      console.info("requestPartnerInfo  :>> ", {
        payload,
        response: response.data
      });
    }

    yield put(selectHospitalInfo(response.data));
  } catch (error) {
    huyi({ name: "requestPartnerInfo ", child: error, type: "error" });
  }
}

function* watcher_requestPartnerInfo() {
  yield takeLatest(types.HOSPITAL_INFO, requestPartnerInfo);
}

function* requestHospitalDescription({ payload }) {
  try {
    console.log("payload", payload);

    const response = yield client.getHospitalDetail({
      slug: "benh-vien-dai-hoc-y-duoc-co-so-1"
    });

    const log = false;
    if (log) {
      console.info("requestPartnerInfo  :>> ", {
        payload,
        response: response.data
      });
    }

    yield put(selectHospitalDescription(response.data));
  } catch (error) {
    huyi({ name: "requestHospitalDescription ", child: error, type: "error" });
  }
}

function* watcher_requestHospitalDescription() {
  yield takeLatest(types.HOSPITAL_DESCRIPTION, requestHospitalDescription);
}

export default function* root() {
  yield all([
    fork(requestReserveMutipleBookingsWatcher),
    fork(requestExtraConfigWatcher),
    fork(watchRequestAllHiddenMedicalBill),
    fork(requestBookingTreeWatcher),
    fork(requestReserveBookingWatcher),
    fork(requestBookingShareToPayWatcher),
    fork(requestRepaymentBookingWatcher),
    fork(requestPaymentInfoWatch),
    fork(watchRequestBookingInfo),
    fork(watchRequestAllMedicalBill),
    fork(watchRequestChangeStepAuto),
    fork(requestSubBookingTreeWatcher),
    fork(watchResetListNode),
    fork(watchReserveBookingPartner),
    fork(watchRequestGoBack),
    fork(watcher_requestPartnerInfo),
    fork(watcher_requestHospitalDescription)
  ]);
}
